import {AuthModel} from '../auth/core/_models'
import {isOnPremisesInstallation} from '../auth/core/onPremisesAccess'
import {businessSettingsPath} from '../online-payment/core/businessSettingsPath'

/**
 * «لینک خریدار» in «امکانات تازه» (user request 2026-10-14): like the proforma, the header's icon shakes until the
 * list is opened, and the item opens this introduction (BuyerLinksIntroGate).
 */
export const BUYER_LINKS_INTRO_EVENT = 'mp:buyer-links-intro'

/** The announcement's id in the user's seen list (whatsNewSeen); a new announcement takes a new id. */
export const BUYER_LINKS_ANNOUNCEMENT = 'buyer-links-1405-07'

export const openBuyerLinksIntro = (): void => {
  window.dispatchEvent(new Event(BUYER_LINKS_INTRO_EVENT))
}

/** Whoever works in a business on the central panel; buyer links and their SMS do not exist on premises. */
export const shouldAnnounceBuyerLinks = (user?: AuthModel | null) =>
  Boolean(user && !user.support && Number(user.cpi || 0) > 0 && !isOnPremisesInstallation(user))

/** «تنظیمات کسب‌وکار ← لینک خریداران» of the selected business. */
export const buyerLinksSettingsPath = (companyId: number) => businessSettingsPath(companyId, 'buyer-links')
